export default "__VITE_ASSET__f8eafe8c__"